<template>
  <v-container id="genericReport" fluid>
    <header
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      "
    >
      <div
        style="
          border-bottom: 1px solid #aaa;
          width: 100%;
          text-align: center;
          margin-bottom: 10px;
        "
      >
        <h2 style="font-weight: 400">{{ $store.getters.getAppName }}</h2>
      </div>
      <img
        :src="
          prefecture.prefecture_logo
            ? $store.state.urlImages + prefecture.prefecture_logo
            : require('@/assets/no-image.jpg')
        "
        :alt="prefecture.social_name ? prefecture.social_name : ''"
        style="width: 30%; padding: 1%"
      />
      <h1 style="font-weight: 400">
        {{
          prefecture.prefecture_social_name
            ? prefecture.prefecture_social_name
            : ""
        }}
      </h1>
      <h4>
        Período de: {{ convertDate(filter.startDate) }} até
        {{ convertDate(filter.endDate) }}
      </h4>
    </header>
    <br />
    <br />

    <table
      class="table"
      style="
        border-collapse: collapse;
        border: 1px solid rgb(214, 214, 214);
        border-top: 0;
        text-align: center;
        width: 100%;
      "
    >
      <thead>
        <tr style="border: 1px solid rgb(214, 214, 214); text-align: center">
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Data/Hora
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Item
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Litros Abastecidos
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Preço Liçitado
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Preço do Dia
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Valor Abastecido
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Número do cupom
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Status
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Motorista
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(value, index) in data.supplies" :key="index">
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ convertDateTime(value.datehour) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.item_description_desc }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ realMaskII(value.supply_liters_stocked.toFixed(3)) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ realMaskII(value.supply_price_day.toFixed(3)) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ realMaskII(value.supply_bidding_price.toFixed(3)) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ realMask(value.supply_value.toFixed(2)) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.supply_coupon }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.supply_status }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.driver_name }}
          </td>
        </tr>
      </tbody>
    </table>
    <table
      class="table"
      style="
        border-collapse: collapse;
        border: 1px solid rgb(214, 214, 214);
        border-top: 0;
        text-align: center;
        width: 100%;
      "
    >
      <thead>
        <tr style="border: 1px solid rgb(214, 214, 214); text-align: center">
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Total de Litros
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Valor Total Dia
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 5px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Valor Total Liçitado
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ realMask(data.totals.liters.toFixed(2)) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ realMask(data.totals.total.toFixed(2)) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ realMask(data.totals.totalBidding.toFixed(2)) }}
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
import helpers from "@/mixins/helpers";
export default {
  props: ["data", "filter", "prefecture"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>